import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { PageRoutes } from "../constants/routes";

export const useNavigation = () => {
  const navigate = useNavigate();

  const navigateToTopPage = useCallback(() => {
    navigate(PageRoutes.HOME);
  }, []);

  const navigateToMyPage = useCallback(() => {
    navigate(PageRoutes.MY_PAGE);
  }, []);

  const navigateToPage = useCallback(
    (path: string, replace?: boolean, state?: any) => {
      navigate(path, { replace, state });
    },
    [],
  );

  const navigateToNewTab = useCallback((path: string) => {
    window.open("#" + path, "_blank");
  }, []);

  return {
    navigateToTopPage,
    navigateToMyPage,
    navigateToPage,
    navigateToNewTab,
  };
};
